import { VACATION_MESSAGE_MAX, type VacationResponse } from '@warcarp/api-types'
export const VACATION_DAY_MS = 86_400_000
export function vacationMessage(value: string) { return Array.from(value).slice(0, VACATION_MESSAGE_MAX).join('') }
export function isVacationActive(vacation: VacationResponse | null | undefined, now: number) {
  return !!vacation && Number.isFinite(Date.parse(vacation.endsAt)) && Date.parse(vacation.endsAt) > now
}
function remainingHours(endsAt: string, now: number) {
  const end = Date.parse(endsAt)
  return Number.isFinite(end) ? Math.max(0, Math.ceil((end - now) / 3_600_000)) : 0
}
export function vacationRemainingLabel(endsAt: string, now: number) {
  const hours = remainingHours(endsAt, now)
  if (!hours) return 'Ending now'
  const days = Math.floor(hours / 24)
  return days ? `${days}d${hours % 24 ? ` ${hours % 24}h` : ''}` : `${hours}h`
}
/** Natural language for dialogs; short breaks stay in hours rather than “1 day and …”. */
export function vacationRemainingText(endsAt: string, now: number) {
  const hours = remainingHours(endsAt, now)
  if (!hours) return 'Ending now'
  if (hours === 24) return '1 day'
  if (hours < 48) return `${hours} ${hours === 1 ? 'hour' : 'hours'}`
  const days = Math.floor(hours / 24)
  const rest = hours % 24
  return `${days} days${rest ? ` and ${rest} ${rest === 1 ? 'hour' : 'hours'}` : ''}`
}
export function vacationRemainingSentence(name: string, endsAt: string, now: number) {
  const duration = vacationRemainingText(endsAt, now)
  return duration === 'Ending now' ? `${name}’s vacation is ending now.`
    : `${name} will be on vacation for another ${duration.replace(/^1 (day|hour)$/, '$1')}.`
}
